/**
 * @generated SignedSource<<e2a543354589cad7ea73b4645c27116e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseContent_photos$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PhotoItem_photo" | "usePhotosLikeDataRefetch_photos">;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "PhotosSearchBrowseContent_photos";
};
export type PhotosSearchBrowseContent_photos$key = {
  readonly " $data"?: PhotosSearchBrowseContent_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseContent_photos">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseContent_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowseQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowsePhoto",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PhotoItem_photo"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "usePhotosLikeDataRefetch_photos"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};

(node as any).hash = "0ca7a3855ed5206ca294966231d3deda";

export default node;
